import { IonButton, IonCol, IonRow } from "@ionic/react";
import React, { useContext, useEffect, useState } from "react";
import { utilService } from "../../../../services";
import { NurseContext } from "../../NurseManagement";
import { NurseManagementService } from "../../NurseManagementService";
import { BedsData, GetBedsListResponse } from "../../NurseMgmtDataModels";
import { useToast } from "@agney/ir-toast";
import { useTranslation } from "react-i18next";
import Loader from "../../../../components/Shared/Loader/Loader";
interface SelectBedProps {
  resetData: boolean;
  setUpdateData: Function;
  setActiveTabInMobile: Function;
}

const SelectBed: React.FunctionComponent<SelectBedProps> = (props) => {
  const Toast = useToast();
  const { t } = useTranslation("nursemanagement");
  const nurseContextData = useContext(NurseContext);
  const [bedsList, setBedsList]: [[], Function] = useState([]);
  const [showLoader, setShowLoader]: [boolean, Function] = useState(false);

  useEffect(() => {
    props.resetData && setBedsList([]);
  }, [props.resetData]);

  useEffect(() => {
    nurseContextData.selectedUnit && getBedList(nurseContextData.selectedUnit);
  }, [nurseContextData.selectedUnit]);

  const getBedList = async (selectedUnit: string) => {
    setShowLoader(true);
    const bedsData: GetBedsListResponse = await NurseManagementService.getBeds({
      unitId: selectedUnit,
      reg_code: utilService.getNetwork(),
    });
    if (bedsData.isSuccess) {
      setBedsList(bedsData.result);
    } else {
      setBedsList([]);
      Toast.error(bedsData.message);
    }
    setShowLoader(false);
  };

  const assignUnAssignBed = (bed: BedsData) => {
    if (nurseContextData.selectedNurseGuid) {
      const arrIndex = bed.assigned_status.guid.indexOf(
        nurseContextData.selectedNurseGuid
      );
      if (arrIndex === -1) {
        if (!bed.assigned_status_patient) {
          Toast.error(t("nurseCannotAssignEmptyBed"));
          return;
        } else {
          bed.assigned_status.guid.push(nurseContextData.selectedNurseGuid);
        }
      } else {
        bed.assigned_status.guid.splice(arrIndex, 1);
      }
      setBedsList([...bedsList]);
      const phoneObjToPass = {
        id: bed.id,
        action: arrIndex === -1 ? "add" : "del",
      };
      props.setUpdateData(
        nurseContextData.selectedUnit,
        nurseContextData.selectedNurseId,
        {},
        phoneObjToPass,
        nurseContextData.selectedNurseGuid,
        "bed"
      );
    }
  };

  useEffect(()=>{
    if(nurseContextData.selectedNurseGuid){
      const selectedBeds:any = bedsList?.filter((bed:any)=>bed?.assigned_status?.guid?.some((id:string)=>id===nurseContextData.selectedNurseGuid))
      if(selectedBeds?.length>0){
        selectedBeds?.forEach((bed:any)=>{
          if(bed?.assigned_status?.guid?.length!==0){
            const phoneObjToPass = {
              id: bed?.id,
              action:"add",
            };
            props.setUpdateData(
              nurseContextData.selectedUnit,
              nurseContextData.selectedNurseId,
              {},
              phoneObjToPass,
              nurseContextData.selectedNurseGuid,
              "bed"
            );
          }
        })
      }
    }
  },[nurseContextData.selectedNurseGuid])

  return (
    <div className="card-container w-100">
      <h5 className="header-text">{t("selectBed")}</h5>
      {showLoader && (
        <div className="loader-container">
          <Loader></Loader>
        </div>
      )}
      {bedsList.length ? (
        <div className="card-content">
          <IonRow className="searchbar-container"></IonRow>
          <IonRow>
            <IonCol size="12">
              <ul className="ul-list">
                {bedsList.map((bed: BedsData) => {
                  return (
                    <li key={bed.id}>
                      <div
                        className={`list-val-container d-flex align-items-center clickable ${
                          utilService.arrayContains(
                            bed.assigned_status.guid,
                            nurseContextData.selectedNurseGuid
                          )
                            ? "selected"
                            : ""
                        }`}
                        onClick={() =>
                          nurseContextData.selectedNurseId &&
                          assignUnAssignBed(bed)
                        }
                      >
                        <span className="icon-bed img-icon bed d-flex align-items-center"></span>
                        <span className="list-val">{bed.name}</span>
                      </div>
                    </li>
                  );
                })}
              </ul>
            </IonCol>
          </IonRow>
        </div>
      ) : (
        <div className="card-content d-flex justify-content-center align-items-center">
          <div className="no-content-msg">
            <div className="no-data-icon icon-no_bed mb-3"></div>
            <div>{t("noBeds")}</div>
          </div>
        </div>
      )}
      <div className="mobile-nav-buttons">
        <IonButton
          className="button tertiary-btn btn-curved"
          onClick={() => props.setActiveTabInMobile(2)}
        >
          {t("prev")}
        </IonButton>
      </div>
    </div>
  );
};

export default SelectBed;
